import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { OrderEmailInvoicePage } from 'src/app/modals/order-email-invoice/order-email-invoice.page';

const routes: Routes = [
  {
    path: '',
    component: OrderEmailInvoicePage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    RouterModule.forChild(routes)
  ],
  declarations: [OrderEmailInvoicePage]
})
export class OrderEmailInvoicePageModule {}
